import Anchor from './anchor.vue';
export default Anchor;



// WEBPACK FOOTER //
// ./src/components/anchor/index.js